import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react'; // Added missing import
import Sidebar from './Sidebar';
import MobileMenu from './MobileMenu';
import { useTheme } from '../../hooks/useTheme';

const Layout = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const { theme } = useTheme();

  return (
    <div className={`flex h-screen ${theme === 'dark' ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
      <MobileMenu show={showMobileMenu} onClose={() => setShowMobileMenu(false)} />
      <Sidebar className="hidden md:block" />
      
      <div className="flex-1 overflow-y-auto">
        <button
          className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-lg bg-white shadow-lg"
          onClick={() => setShowMobileMenu(true)}
        >
          <Menu className="w-6 h-6" />
        </button>
        
        <div className="p-6 md:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;